/**
 * Exportação das abas Ganhos / Perdidos / Arquivados (CRM-45) — funções
 * puras (sem jsPDF/xlsx) para testar direto.
 *
 * As colunas são as visíveis na tabela, mais o motivo (e o detalhe) da perda
 * na aba Perdidos — "os perdidos do mês por motivo" é a pergunta da reunião.
 * A data é a do desfecho da aba (`dataCampo`), a mesma que ordena a lista.
 */

export function nomeDoLead(lead) {
  return (
    lead.cliente_nome
    || [lead.contato_nome, lead.contato_sobrenome].filter(Boolean).join(" ")
    || "Sem cliente"
  );
}

/** Uma linha exportável a partir de um item de `listarLeads`. */
export function linhaTerminal(lead, dataCampo) {
  return {
    lead: nomeDoLead(lead),
    numero: lead.numero || "",
    titulo: lead.titulo || "",
    status: lead.status_display || lead.status || "",
    responsavel: lead.responsavel_nome || "",
    motivo: lead.motivo_perda_display || lead.motivo_perda || "",
    motivo_detalhe: lead.motivo_perda_detalhe || "",
    data: lead[dataCampo] || lead.created_at || "",
    valor_estimado: Number(lead.valor_estimado) || 0,
  };
}

const COLUNAS_BASE = [
  { key: "lead", label: "Lead", type: "text" },
  { key: "numero", label: "Número", type: "text" },
  { key: "titulo", label: "Descrição", type: "text" },
  { key: "status", label: "Status", type: "text" },
  { key: "responsavel", label: "Responsável", type: "text" },
];

const COLUNAS_MOTIVO = [
  { key: "motivo", label: "Motivo da perda", type: "text" },
  { key: "motivo_detalhe", label: "Detalhe do motivo", type: "text" },
];

/** Colunas da aba: as da tabela + motivo (só Perdidos) + data + valor. */
export function colunasTerminais({ dataLabel, mostraMotivo }) {
  return [
    ...COLUNAS_BASE,
    ...(mostraMotivo ? COLUNAS_MOTIVO : []),
    { key: "data", label: dataLabel, type: "date" },
    { key: "valor_estimado", label: "Valor", type: "currency" },
  ];
}

/** {titulo, resumo, secoes} no shape que utils/exportacao consome. */
export function montarExportacaoTerminal({ cfg, leads, periodo }) {
  const linhas = leads.map((lead) => linhaTerminal(lead, cfg.dataCampo));
  const soma = linhas.reduce((acc, l) => acc + l.valor_estimado, 0);
  const resumo = [
    { label: cfg.plural, value: linhas.length, type: "number" },
    { label: "Valor estimado", value: soma, type: "currency" },
  ];
  if (periodo) resumo.push({ label: "Período", value: periodo, type: "text" });
  return {
    titulo: `CRM — ${cfg.titulo}`,
    resumo,
    secoes: [
      {
        id: "leads",
        label: cfg.titulo,
        columns: colunasTerminais(cfg),
        rows: linhas,
      },
    ],
  };
}
